import { render } from "./UserCreate.vue?vue&type=template&id=7bc3ba53"
import script from "./UserCreate.vue?vue&type=script&lang=js"
export * from "./UserCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__